<template>
	<chatbot
		:alerts="alerts"
		:translations="translations"
		:code="code"
		:prevent-unload="preventUnload"
		:show-chatbot="showChatbot"
		:title="title"
		@close="closeChat"
	/>
</template>

<script>
	import Message from "./chatbotInstructions/Message";
	import Call from "./chatbotInstructions/Call";
	import Select from "./chatbotInstructions/Select";
	import SelectOption from "./chatbotInstructions/SelectOption";
	import Form from "./chatbotInstructions/Form";
	import FormField from "./chatbotInstructions/FormField";
	import Custom from "./chatbotInstructions/Custom";
	import Restart from "./chatbotInstructions/Restart";
	import Flashes from "./chatbotInstructions/Flashes";

	export default {
		props: {
			translations: {
				type: Object,
				required: true,
			},
			urls: {
				type: Object,
				required: true,
			},
			alerts: {
				type: Object,
				required: true,
			},
			showChatbot: {
				type: Boolean,
				required: true,
			},
			title: {
				type: String,
				default: ''
			},
			product: {
				type: String,
				default: 'mobi'
			},
			modifiedBudgets: {
				type: Object,
				required: true,
			},
		},
		data ()
		{
			const trans = this.translations.fileImport;
			const modified = this.modifiedBudgets;
			const self = this;

			return {
				preventUnload: false,
				code: {
					/*
					 * Entry point
					 */
					main: [
						new Call('download_or_upload'),
					],
					download_or_upload: [
						new Message(trans.download_or_upload.intro),
						new Select(
							'nextCall',
							[
								new SelectOption('download', trans.download_or_upload.options.download.label).hasHref(self.urls.template),
								new SelectOption('upload', trans.download_or_upload.options.upload.label),
							]
						),
						new Message((variables) => trans.download_or_upload.options[variables.nextCall].response)
							.isFromUser(),
						new Call((variables) => variables.nextCall),
					],
					download: [
						new Message(trans.download.intro),
						new Select(
							null,
							[new SelectOption(null, trans.download.button)]
						),
						new Message(trans.download.response).isFromUser(),
						new Call('upload'),
					],
					upload: [
						new Message(trans.upload.intro),
						new Message(trans.upload.warning),
						new Call(
							function()
							{
								self.preventUnload = true;
								clearError();
							}
						),
						new Form(
							trans.upload.submit,
							[
								new FormField('file', trans.upload.field).isFile().isRequired(),
							]
						).validateWith(
							async function(variables)
							{
								let formData = new FormData();
								formData.append('file', variables.file[0]);
								variables.processed = false;

								if(['text/csv'].includes(variables.file[0]['type']))
								{
									return new ApiMonizze()
										.postDataFromApi(
											self.urls.send,
											formData,
											function(data, res)
											{
												if (res.success)
												{
													variables.processed = true;
													self.preventUnload = false;
													Object.keys(data).map(userId => {
														modified[userId] = data[userId];
													});
												}
											}
										);
								}
								else if (!variables.processed)
								{
									await new Promise(resolve => setTimeout(resolve, 1000));
								}
							}
						),
						new Message(trans.upload.response).isFromUser(),
						new Call('confirmed').if((variables) => variables.processed),
						new Call('error').if((variables) => !variables.processed),
					],
					error: [
						new Flashes((variables) => variables.errors),
					  	new Message((variables) => variables.warnings, true).if((variables) => variables.warnings),
						new Message(trans.error.intro),
						new Select(
							'nextCall',
							Object.entries(trans.error.options)
								.map(([key, value]) => new SelectOption(key, value.label))
						),
						new Message((variables) => trans.error.options[variables.nextCall].response)
							.isFromUser(),
						new Call((variables) => variables.nextCall),
					],
					confirmed: [
						new Message(trans.confirmed.intro),
						new Call('help'),
					],
					help: [
						new Message(trans.help.intro),
						new Select(
							'nextCall',
							[
								new SelectOption('close', trans.help.options.close.label),
							]
						),
						new Call('close'),
					],
					close: [
						new Custom(
							function() {
								self.closeChat();
							}
						)
					]
				},
			}
		},
		methods: {
			closeChat()
			{
				this.$emit('close');
			}
		}
	}
</script>
